import React, {useState} from 'react';
import useSWR from "swr";
import {getHttpClient, setAccessToken, swrFetcher} from "../../utils/api.ts";
import {FiPlus} from "react-icons/fi";
import Input from "../../components/form/Input.tsx";
import {Link} from "wouter";
import {useInvalidateAllQueries} from "../../components/hooks/useInvalidateAllQueries.ts";
import Spinner from "@/components/spinner.tsx";
import Modal from "@/components/Modal.tsx";
import {closeModal, openModal} from "@/components/dispatch_functions.ts";
import Button from "@/components/form/Button.tsx";

function WorkspaceHome() {
    const {data, isLoading, mutate} = useSWR('/me/workspaces', swrFetcher)
    const [name, setName] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const createWorkspace = ()=>{
        setLoading(true)
        getHttpClient().post('/me/workspaces',{
            name
        }).then(()=>{
            setLoading(false)
            mutate()
            closeModal("create-workspace")
        })
    }
    const invalidateAllQueries = useInvalidateAllQueries()
    const [switching, setSwitching] = useState(0)
    const switchWorkspace = (id)=>{
        setSwitching(id)
        getHttpClient().post(`/auth/with_workspace`,{
            workspace_id: id
        }).then(({data})=>{
            setSwitching(0)
            if(data.access_token){
                setAccessToken(data.access_token)
                invalidateAllQueries()
            }
        })
    }
    return (
        <div className={"mb-2"}>
            <Modal
                   confirmLoading={loading}
                   id={"create-workspace"}
                   disabled={!name}
                   okText={"Submit"}
                   onSubmit={createWorkspace}
                   title={"Create a new workspace"}>
                <Input value={name} label={"Name"} placeholder={"Name"} onChange={setName} />
            </Modal>
            <div className="card">
                <div className="space-between">
                    <span className={"card-title"}>My workspaces</span>
                    <button
                        onClick={()=>openModal("create-workspace")}
                        className={"btn btn-ghost"}><FiPlus /> CREATE</button>
                </div>
                <div>
                {
                    isLoading ? <div className="card-body py-4 text-center">
                        <Spinner />
                        </div> : null
                }
                <ul className="divide-y divide-base-200 rounded border border-base-200">
                    {
                        data?.workspaces.map((i)=> {
                            return <li key={String(i.id)} className="p-3 space-between">
                                <Link to={`/settings/workspaces/${i.id}`}>
                                {i.workspace.name || 'No Name'}
                                </Link>
                                {
                                    i.is_current ? <span className={"text-sm bg-base-100 px-3 py-1 rounded-full "}>Current</span> :
                                        <Button
                                            className={"btn btn-neutral"}
                                            disabled={switching > 0}
                                            loading={switching === i.id}
                                            onClick={()=>switchWorkspace(i.id)}>Switch</Button>
                                }
                            </li>

                        })
                    }
                </ul>
                </div>

            </div>

        </div>
    );
}

export default WorkspaceHome;
